// [S-475] Preserve the MCP OAuth consent URL across a login round-trip.
//
// The MCP server's GET /authorize 302s the browser to the web consent page
// (MCP_AUTHORIZE_WEB_URL → /mcp-consent?client_id=…&code_challenge=…&state=…).
// If the user isn't signed in, RequireRole/Login would normally drop them on
// /home and lose those query params — breaking the OAuth handoff. So an
// unauthenticated hit stashes the full intended URL here; Login reads it back
// after a successful sign-in and returns the user to the consent screen.
//
// sessionStorage (not react-router state) because it survives the in-tab
// Identity Platform sign-in. Scoped + same-origin; we only ever write our own
// in-app path and Login re-validates it starts with "/".
const KEY = "csai.mcp_oauth_return";

export function stashOAuthReturn(pathWithSearch: string): void {
  try {
    sessionStorage.setItem(KEY, pathWithSearch);
  } catch {
    // Private-mode / disabled storage — degrade to the /home default.
  }
}

/** Read and clear the stashed return URL. Returns null when none is pending. */
export function takeOAuthReturn(): string | null {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v !== null) sessionStorage.removeItem(KEY);
    return v;
  } catch {
    return null;
  }
}
